export const TOOLTIP_ROOT = 'share-dialog-tooltip-root';
export const createDataLookup = elementName => elementName ? `share-dialog-${elementName}` : undefined;
export const EIGHT = 8;
export const FOOTER_HEIGHT = EIGHT * 9;
export const HEADING_Z = 3;
export const FOOTER_Z = 2;
export const SUB_HEADING_Z = 1;